import { setupOidcClient } from "./oidc/setup";

export function setupClient(clientId) {
  return setupOidcClient({
    identityProviderUri:
      "https://login.microsoftonline.com/db05faca-c82a-4b9d-b9c5-0f64b6755421/v2.0",
    clientId: clientId,
    appUri: location.origin + "/",
    redirectUri: location.origin + "/auth",
    postLogoutRedirectUri: location.origin + "/",
    responseType: "code",
    scopes: ["openid", "profile", "email"],
    signInRedirectParams: {
      state: {
        finalRedirectUri: location.href,
      },
    },
  });
}
